<template>
  <div class="task-detail-meta-options">
    <!-- ATTACHMENTS -->
    <attachments-dropdown
      v-if="hasGlobalAttachments"
      :list-attachments="globalAttachments"
    />
    <!-- HARVEST OPTION -->
    <div v-if="showHarvestOption && $permissions.isNotGuest" class="task-detail-meta-options__harvest">
      <i class="ddi ddi-harvest" @click="$emit('show-harvest-modal')" />
    </div>
    <!-- PIN TO DASHBOARD -->
    <el-tooltip>
      <template #content>
        <div>{{ pinLabel }}</div>
      </template>
      <dd-icon-button 
        :color="isPinned ? ColorAssistant.ProjectColor : 'grey'" 
        icon="pin" 
        type="circle" 
        size="small"
        @click.stop="togglePin()" 
      />
    </el-tooltip>
    <!-- MORE OPTIONS -->
    <div v-if="$permissions.isNotGuest" class="task-detail-meta-options__more">
      <more-button-dropdown
        :force-visibility="showMoreOptions"
        popper-min-width-size="small"
        placement="bottom-end"  
      >
        <template #options-list>
          <ul>
            <li @click="togglePin()">
              <i class="ddi ddi-pin" />
              <span>{{ pinLabel }}</span>
            </li>
            <li @click="$emit('move-clicked')">
              <i class="ddi ddi-move-up" />
              <span>Move&hellip;</span>
            </li>
            <li v-if="$permissions.isAdminOrOwner" class="scary-list-option" @click="$emit('delete-clicked')">
              <i class="ddi ddi-trash" />
              <span>Delete</span>
            </li>
          </ul>
        </template>
      </more-button-dropdown>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from '@/components/global/content-placeholders'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IAttachment } from '@/types/data-objects/attachments'
/* API */

export default defineComponent({
  name: 'TaskDetailMetaOptions',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    globalAttachments: {
      type: Array as () => IAttachment[],
      required: true,
    },

    showHarvestOption: {
      type: Boolean,
      required: true,
    },

    isPinned: {
      type: Boolean,
      required: true,
    },
  },

  emits: [
    'delete-clicked',
    'move-clicked',
    'pin-toggled',
    'show-harvest-modal',
  ],

  data() {
    return {
      EEntities,
      ColorAssistant,
      RouteAssistant,
      showMoreOptions: false,
    }
  },

  computed: {
    hasGlobalAttachments(): boolean {
      return this.globalAttachments.length > 0
    },
    pinLabel(): string {
      return this.isPinned ? 'Unpin from dashboard' : 'Pin to dashboard'
    },
  },

  methods: {
    togglePin() {
      this.$emit('pin-toggled')
      this.closeMoreOptions()
    },
    closeMoreOptions() {
      this.showMoreOptions = true
      this.$nextTick(() => {
        this.showMoreOptions = false
      })
    },
  },
})
</script>

<style lang="scss">
.task-detail-meta-options {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: fit-content;
  height: $item-detail-header-bar-desktop-height;
  @include flex-row-horizontal-spacing(12px);

  @include media-breakpoint-down(sm) {
    height: $item-detail-header-bar-mobile-height;
  }

  &__harvest {
    cursor: pointer;

    .ddi-harvest {
      font-size: 22px;
    }
  }

  &__more {
    margin-right: -8px; // Square up to right-edge of container
  }
}
</style>
